(function () {
  'use strict';

  angular
    .module('web2print')
    .factory('FileUpload', FileUpload);

  FileUpload.$inject = ['$http', '$translate', '$q', '$mdDialog', 'Upload'];

  /* @ngInject */
  function FileUpload ($http, $translate, $q, $mdDialog, Upload) {
    const service = {
      upload: uploadMultiple,
      uploadSingleFile: uploadSingleFile,
      invalidFileError: invalidFileError
    };

    return service;

    function uploadSingleFile (file, subFolder, renameFile, meta) {
      const options = {
        folder: subFolder,
        name: renameFile || file.name,
        type: file.type,
        meta: meta
      };
      console.log(options);

      return $http.post(web2print.env.recipientsBaseUrl + 'generatePresigned', options)
        .success(function (response) {
          options.folder = response.folder;

          response.config = options;
          return response;
        });
    }

    function uploadMultiple (files, invalidFiles) {
      // $scope.validateFile(invalidFiles);

      files.forEach(function (file) {
        uploadSingleFile(file);
      });

    }

    function invalidFileError (invalidFile) {
      if (invalidFile) {
        const invalidFilesAlert = $mdDialog.alert({
          title: $translate.instant('INVALID_FILES_TITLE'),
          textContent: $translate.instant('INVALID_FILES_TEXT'),
          ok: $translate.instant('INVALID_FILES_OK')
        });

        $mdDialog.show(invalidFilesAlert);
      }

    }
  }
})();
